<template>
	<app-button
		icon="filters"
		class="btn btn-primary transparent small advanced-filter-button"
		@click="open"
		:loading="loading"
	>
		{{ buttonTitle }}
	</app-button>

	<teleport to="#app">
		<div :class="`app-advanced-filter ${modalOpen ? 'opened' : ''}`">
			<div
				class="flex flex-col p-4"
				:class="{ 'overflow-y-auto': sticky }"
				:style="sticky ? { height: 'calc(100vh - 105px)' } : {}"
			>
				<app-section class="flex flex-col">
					<slot />
				</app-section>
			</div>
			<app-section class="flex mx-4 gap-4">
				<app-button class="flex flex-1 mr-2 btn btn-success" @click="filter()">{{ $t('filter') }}</app-button>
				<app-button class="flex flex-1 ml-2 btn btn-warning" @click="clear()">{{ $t('clear') }}</app-button>
			</app-section>
		</div>
	</teleport>
</template>

<script>
	export default {
		name: 'AppAdvancedFilter',
		props: {
			buttonTitle: String,
			loading: Boolean,
			sticky: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['onFilter', 'onClear', 'onClick'],
		data() {
			return {
				modalOpen: false,
				delayedModalOpen: false,
			};
		},
		methods: {
			open() {
				if (!this.modalOpen) {
					this.$emit('onClick');
					this.modalOpen = true;
					setTimeout(() => {
						this.delayedModalOpen = true;
					}, 100);
				}
			},
			close() {
				this.modalOpen = false;
				this.delayedModalOpen = false;
			},
			filter() {
				this.close();
				this.$emit('onFilter');
			},
			clear() {
				this.close();
				this.$emit('onClear');
			},
		},
		mounted() {
			this.emitter.on('appContentClicked', () => {
				if (this.delayedModalOpen) {
					this.close();
				}
			});
		},
	};
</script>
